/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddSessionToGroupRequest
 */
export interface AddSessionToGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof AddSessionToGroupRequest
     */
    sessionId?: string;
    /**
     * 
     * @type {number}
     * @memberof AddSessionToGroupRequest
     */
    order?: number | null;
}

/**
 * Check if a given object implements the AddSessionToGroupRequest interface.
 */
export function instanceOfAddSessionToGroupRequest(value: object): value is AddSessionToGroupRequest {
    return true;
}

export function AddSessionToGroupRequestFromJSON(json: any): AddSessionToGroupRequest {
    return AddSessionToGroupRequestFromJSONTyped(json, false);
}

export function AddSessionToGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddSessionToGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function AddSessionToGroupRequestToJSON(json: any): AddSessionToGroupRequest {
    return AddSessionToGroupRequestToJSONTyped(json, false);
}

export function AddSessionToGroupRequestToJSONTyped(value?: AddSessionToGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'order': value['order'],
    };
}

